import { Stack, Text } from '@sixui/ui';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IContentBlockEmptyProps = IContainerProps & {
  title?: string;
  subtitle?: string;
  children?: React.ReactNode;
};

const styles = stylex.create({
  host: {
    position: 'relative',
    padding: '4rem',
    color: colorSchemeTokens.onSurface,
  },
  container: {
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    paddingTop: '1.25rem',
    paddingBottom: '1.25rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  inner: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const ContentBlockEmpty: React.FC<IContentBlockEmptyProps> = (props) => {
  const { sx, title, subtitle: headline, children } = props;

  return (
    <div {...stylex.props(styles.host, sx)}>
      <div {...stylex.props(styles.container)}>
        <Stack gap={4}>
          {title ? (
            <Text variant="title" size="md">
              {title}
            </Text>
          ) : null}
          {headline ? (
            <Text variant="body" size="md">
              {headline}
            </Text>
          ) : null}
          {children ? <div>{children}</div> : null}
        </Stack>
      </div>
    </div>
  );
};
